export const extractIframeMessageData = ({
  event,
  messagePrefix,
}: {
  event: MessageEvent;
  messagePrefix: string;
}) => {
  const { data } = event;
  if (typeof data === 'string' && data.includes(messagePrefix)) {
    return JSON.parse(data.split(messagePrefix)[1]);
  }
  return {};
};
